import { tracs_api } from "../../services/api.interceptor";
import { TableStatsTypes } from "../interfaces/dashboardmodels";

class DashboardService{
    getTableStats(type:TableStatsTypes){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Dashboard/GetTableStatitics?type="+type+"&tocId="+(toc?toc?.Id:0));
    }
}

export default new DashboardService();